var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "480px",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      on: { close: _vm.onClose },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("Title", {
                staticClass: "mb-4",
                attrs: { title: "Conectar WhatsApp", underlined: "" }
              })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "mt-4 d-flex" },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c(
          "div",
          { staticClass: "modal-content text-center" },
          [
            _vm.estado !== "erro"
              ? _c(
                  "p",
                  { staticClass: "az-text-primary az-size-14 az-muted mb-6" },
                  [
                    _vm._v(" Abra o WhatsApp no seu celular, vá em "),
                    _c("strong", [
                      _vm._v(
                        " Configurações > Aparelhos conectados > Conectar um aparelho "
                      )
                    ]),
                    _vm._v(" e escaneie o QR Code abaixo. ")
                  ]
                )
              : _vm._e(),
            _c("v-fade-transition", { attrs: { mode: "out-in" } }, [
              _vm.estado === "carregando"
                ? _c(
                    "div",
                    {
                      key: "carregando",
                      staticClass:
                        "d-flex flex-column justify-center align-center py-8"
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          size: "48"
                        }
                      }),
                      _c(
                        "p",
                        {
                          staticClass:
                            "az-text-primary az-size-14 az-muted mt-4 mb-1"
                        },
                        [_vm._v(" " + _vm._s(_vm.textos.gerando) + " ")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "az-text-primary az-size-12 az-muted mb-0"
                        },
                        [_vm._v(" " + _vm._s(_vm.textos.demora) + " ")]
                      )
                    ],
                    1
                  )
                : _vm.estado === "qrcode"
                ? _c(
                    "div",
                    {
                      key: "qrcode",
                      staticClass: "d-flex justify-center align-center py-2"
                    },
                    [
                      _c("img", {
                        staticClass: "qrcode-image",
                        attrs: {
                          src: _vm.qrCodeBase64,
                          alt: "QR Code WhatsApp"
                        }
                      })
                    ]
                  )
                : _c(
                    "div",
                    {
                      key: "erro",
                      staticClass:
                        "d-flex flex-column justify-center align-center py-8"
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "error-circle", size: 40 }
                      }),
                      _c(
                        "p",
                        {
                          staticClass:
                            "az-text-primary az-size-14 az-muted mt-4 mb-4 erro-texto"
                        },
                        [_vm._v(" " + _vm._s(_vm.mensagemErro) + " ")]
                      ),
                      _c(
                        "BaseButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.tentarNovamente }
                        },
                        [_vm._v(" " + _vm._s(_vm.textos.tentarNovamente) + " ")]
                      )
                    ],
                    1
                  )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }